import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  background-color: #000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #fff;
`;

const BackLink = styled(Link)`
  position: fixed;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1rem;
  color: white;
  text-decoration: none;
  text-align: center;
  transition: transform 0.3s;
  &:hover {
    transform: translateX(-50%) scale(1.2);
  }
`;

const Title = styled.h1`
  font-size: 2.5em;
  color: #fff;
  margin-bottom: 0.5rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
`;

const Input = styled.input`
  background: #111;
  color: #fff;
  border: 1px solid #2a2a2a;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 0.95em;
  margin-bottom: 12px;
  outline: none;
  transition: border-color 0.2s;
  &::placeholder { color: #555; }
  &:focus { border-color: #555; }
`;

const TextArea = styled.textarea`
  background: #111;
  color: #fff;
  border: 1px solid #2a2a2a;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 0.95em;
  margin-bottom: 12px;
  resize: vertical;
  outline: none;
  font-family: inherit;
  transition: border-color 0.2s;
  &::placeholder { color: #555; }
  &:focus { border-color: #555; }
`;

const Button = styled.button`
  background: #fff;
  color: #000;
  border: none;
  border-radius: 6px;
  padding: 12px 32px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;
  transition: opacity 0.2s;
  &:hover { opacity: 0.85; }
`;

const ThankYou = styled.p`
  font-size: 1.1em;
  color: #aaa;
  margin-top: 0.5rem;
`;

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <PageContainer>
        <BackLink to="/">↑<br/>Back</BackLink>
        <Title>Thanks!</Title>
        <ThankYou>I'll get back to you soon.</ThankYou>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <BackLink to="/">↑<br/>Back</BackLink>
      <Title>Get in Touch</Title>
      <Form
        action="https://formspree.io/f/xzdywvnw"
        method="POST"
        onSubmit={() => setSubmitted(true)}
      >
        <Input type="text" name="name" placeholder="Name" required />
        <Input type="email" name="email" placeholder="Email" required />
        <TextArea name="message" placeholder="Message" rows="5" required />
        <Button type="submit">Send</Button>
      </Form>
    </PageContainer>
  );
}

export default Contact;
